import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 24px 0;
  width: 100%;
`;

export const Button = styled.div`
  transition: all 200ms;
  background-color: ${({ theme }) => theme.colors.postnav.background};
  border: 1px solid #4A4A49;
  border-radius: 3px;
  box-shadow: 0 3px 8px 0 rgba(116,129,141,.5);

  a {
    display: flex;
    text-decoration: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 6px 12px;

    svg {
      width: 25px;
      height: 25px;
      color: ${({ theme }) => theme.colors.postnav.link};
      margin-left: 16px;
    }

    h3 {
      color: ${({ theme }) => theme.colors.postnav.link};
      border: none;
      margin: 0;
      padding: 0;
      font-weight: normal;
      font-size: 16px;
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.postnav.backgroundActive};

    a svg {
      color: ${({ theme }) => theme.colors.postnav.linkActive};
    }

    a h3 {
      color: ${({ theme }) => theme.colors.postnav.linkActive};
    }
  }
`;
